import { Link } from "@inertiajs/react";
import Steps, { Step } from "@/components/help/Steps";
import Callout from "@/components/help/Callout";

export default function ConnectingSquare() {
  return (
    <>
      <p>
        Donations to your read-a-thon go straight into your school's bank account through Square — they never pass through PagePledge. Connecting Square is a one-time step in the setup guide. It opens up once your first campaign's fee is paid and we've approved it. Your campaign can't go live until it's done, and a new Square account has to verify its bank account before card payments go through, so it's worth starting early.
      </p>

      <Callout variant="note" title="You probably already have a Square account">
        <p>
          Most Canadian schools, PTAs, and charities use Square already. Ask your finance person — they likely have the login. If they'd rather connect it themselves, invite them as a school admin from the same step. If you genuinely don't have one yet, you can sign up at squareup.com first.
        </p>
      </Callout>

      <h2>How to connect</h2>
      <Steps>
        <Step title="In the setup guide, click Connect Square">
          <p>It's the <strong>Connect Square</strong> step. (Once you've launched, you'll find Square under <strong>Settings</strong> instead.)</p>
          <p>
            First, tick the box to confirm you understand how the money works: Square always charges its card processing fee on each donation (donors can choose to add it to their donation so your school gets the full amount), donations go straight into your Square account, PagePledge takes no percentage, and PagePledge doesn't issue charitable tax receipts. The button unlocks once it's ticked.
          </p>
        </Step>
        <Step title="Sign in to Square and say yes">
          <p>
            We'll send you over to Square. Sign in with your school's Square login and approve the connection. Square will tell you exactly what it's letting us do — accept donations on your behalf and check that they went through. We never see your password.
          </p>
        </Step>
        <Step title="Pick where the money goes">
          <p>
            If your school has more than one Square location, pick the one you want donations deposited to. Most schools just have the one — usually their school name.
          </p>
        </Step>
        <Step title="You're done">
          <p>
            You'll land back in the setup guide with Square showing as connected. Next up is adding your students.
          </p>
        </Step>
      </Steps>

      <Callout variant="privacy" title="We never see card numbers or your bank info">
        <p>
          Card details go from the donor straight to Square — they never pass through PagePledge. Where Square deposits the money is set up inside Square, not here. We don't store anything sensitive.
        </p>
      </Callout>

      <h2>If something didn't work</h2>
      <p>
        If Square told you "authorization failed," it usually means the person trying to connect doesn't own the Square account. Ask whoever set up Square at your school to do this step. If you connected the wrong location by accident, click <strong>Disconnect</strong> under <strong>Settings</strong> and try again — no donations are affected.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/importing-roster-csv">Add your students</Link> — the next step in the setup guide.</li>
        <li><Link href="/help/articles/fees-and-pricing">How fees and pricing work</Link>.</li>
        <li><Link href="/help/articles/tracking-donations">Tracking donations</Link>.</li>
      </ul>
    </>
  );
}
